<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  filteredTags: (selectableTags$ | async) ?? [],
  selectedTags: (selectedTags$ | async) ?? [],
  editingTag: (editingTag$ | async) ?? null
}"> </ng-container>


<ng-template #template let-filteredTags="filteredTags" let-selectedTags="selectedTags" let-editingTag="editingTag">
  <div class="menu-section">
    <div flexLayout="column" flexLayoutAlign="start stretch">
      @for (tag of selectedTags; track trackTagById($index, tag)) {
        <div [class.editing]="editingTag?.tagId === tag.tagId"
          class="menu-item selected" flexLayout="row" flexLayoutAlign="space-between center">
          <div>{{tag.displayName}}</div>
          <mat-icon (click)="removeSelected(tag)">close</mat-icon>
        </div>
      }
      @for (tag of filteredTags; track trackTagById($index, tag)) {
        <div class="menu-item" flexLayout="row"
          flexLayoutAlign="start center" (click)="addSelected(tag)">
          <div>{{tag.displayName}}</div>
        </div>
      }
    </div>
  </div>
</ng-template>
